export default "__VITE_ASSET__CHGl9B3J__"